import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MachinePartInfo, MachinePartInfoService } from 'src/api/generated';
import DataSource from 'devextreme/data/data_source';
import { FilterDescriptor } from 'devextreme/data';
import { CommonsService } from './commons.service';
import { MachineInfoMainService } from './machine-info.service';
import { MessagesService } from './messages.service';

@Injectable({
  providedIn: 'root'
})
export class MachinePartInfoData {

  public dataSource: DataSource;
  public IsActive: boolean = false;

  protected _currentFilter: FilterDescriptor | Array<FilterDescriptor> = [];

  protected _currentRow: BehaviorSubject<MachinePartInfo | undefined> = new BehaviorSubject<MachinePartInfo | undefined>(undefined);
  public currentRow$: Observable<MachinePartInfo | undefined> = this._currentRow.asObservable();

  
  private _chunks: BehaviorSubject<Array<any> | undefined> = new BehaviorSubject<Array<any> | undefined>(undefined);
  public chunks$: Observable<Array<any> | undefined> = this._chunks.asObservable();

  public _data: BehaviorSubject<MachinePartInfo | undefined> = new BehaviorSubject<MachinePartInfo | undefined>(undefined);
  public data$: Observable<MachinePartInfo | undefined> = this._data.asObservable();

  constructor(
    protected _commonSvc: CommonsService, 
    private readonly _machinePartInfoSvc: MachinePartInfoService,
    private readonly _miSvc: MachineInfoMainService,
    private readonly _msgSvc: MessagesService  
  ) {
    this.dataSource = this._commonSvc.makeAsyncDataSource<MachinePartInfo, string, MachinePartInfoService>(this._machinePartInfoSvc, this._currentRow, this.filterForCurrentMachine.bind(this));
    this.Init();
  }

  protected Init(): void {
    this._miSvc.currentFilter$.subscribe({
      next: (f) => {
        this._currentFilter = f;
        if(this.IsActive){
          this.dataSource?.reload();
        }
      }
    });
  }

  private filterForCurrentMachine(filter: FilterDescriptor | Array<FilterDescriptor>): FilterDescriptor | Array<FilterDescriptor> {
    if (filter != null) {
      return [
        filter,
        "and",
        this._currentFilter
      ];
    } else {
      return this._currentFilter;
    }
  }

  public set CurrentRowId(id: string){
    this._miSvc.CurrentRowId = id;
  }

  public set CurrentRow(r: MachinePartInfo) {
    this._currentRow.next(r);
  }

  public reloadDataSource() {
    this.dataSource = this._commonSvc.makeAsyncDataSource<MachinePartInfo, string>(this._machinePartInfoSvc, this._currentRow, this.filterForCurrentMachine.bind(this));
  }

  public LoadData(id: string): void {
    this._machinePartInfoSvc.getOne(id).subscribe({
      next: res => {
        let array = res.ShotStats;
        let tmp: Array<any> = new Array<any>();
        if(array){
          for (let i = 0; i < array.length; i += 8) {
              tmp.push(array.slice(i, i + 8));
          }
          this._chunks.next(tmp);
        }
        res.ShotStats
        this._data.next(res);
      },
      error: (e: HttpErrorResponse) => {
        this._msgSvc.ShowError(e.message);
      }
    });
  }
}
